moment = require("moment");

times = document.querySelectorAll(".translate-time")
let format = "LT Do MMM. YYYY";
times.forEach(function(element){
    let raw_time = element.innerHTML;
    let parsed_moment = moment(raw_time);
    let element_format = element.getAttribute("data-format");
    if(element_format !== null){
        format = element_format;   
    }
    element.innerHTML = parsed_moment.format(format);
});
